import { Link } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

import { ROUTES } from 'routes'

import { HowItWorksCard } from '../HowItWorksCard'
import { SectionNote } from '../shared'

/**
 * The two programmes and where each number comes from. The rules quoted here are the ones
 * `apps/api/src/domain/referrals/referral.constants.ts` enforces (VRG-649); if those
 * constants change, this copy has to change with them.
 */
const STEPS: ReadonlyArray<{ title: string; body: string }> = [
  {
    title: 'Refer & earn',
    body:
      'A brand on Vera refers another brand, by invitation email or by sharing its referral link. The first recorded touch wins; later touches are kept as superseded, and rule-breaking ones as ineligible with a reason.',
  },
  {
    title: 'What the referrer earns',
    body:
      'Activations worth 20% of what the referred brand pays in its first 12 months, at $25 an activation: at least 10 on its first paid invoice, at most 1,000 per referral. They never expire. A refund or credit note takes the matching credits back, never below a zero balance.',
  },
  {
    title: 'What the referred brand gets',
    body:
      '20% off its base plan for its first 3 monthly invoices, or 5% off its first annual invoice.',
  },
  {
    title: 'Vera Insiders',
    body:
      'Individuals introduce brands through a FirstPromoter link and are paid cash commission. vera-2 records each Insider prospect from the waitlist form and reports the signup to FirstPromoter when the company is created. Commission and payouts live in FirstPromoter.',
  },
  {
    title: 'Where the numbers come from',
    body:
      "Refer & earn and Insider prospects: vera-2's own referral records and activation ledger, read live. Active Insiders, leads and commission: FirstPromoter's API, cached for 15 minutes, and shown only once the account is connected.",
  },
  {
    title: 'Which referrals a range counts',
    body:
      'The funnel, credits and top companies follow referrals created in the range to wherever they are today. The weekly chart counts each event in the week it happened. Outstanding credits are a balance, so they are counted now.',
  },
]

export const AffiliatesHowItWorks = () => {
  return (
    <HowItWorksCard
      id="affiliates-how-it-works"
      storageKey="vera.affiliates.howItWorks.open"
      summary="two programmes, their rules, and the data behind each figure"
      steps={STEPS}
      footer={
        <SectionNote>
          Every referral, with its status, credits and staff actions, is under All referrals on the{' '}
          {/* Same page, another tab: primary wayfinding, so no referrer state (§42). */}
          <Link component={RouterLink} to={`${ROUTES.INTERNAL_GTM_AFFILIATES}?tab=refer`}>
            Refer &amp; earn
          </Link>{' '}
          tab. Each figure on this page is defined in the internal glossary.
        </SectionNote>
      }
    />
  )
}
